define([], function Flash(){

    function init(){
        const dismissButton = '<button type="button" class="link-style pos_fr flash-dismiss" ' +
            'aria-label="Dismiss message"><i class="fa fa-times" aria-hidden="true"></i></button>';
        $('#flash p').not(':has(.flash-dismiss)').append(dismissButton);
        $('#flash .flash-dismiss').click(() => { $('#flash').hide(); });
    }

    return {
        init: init
    }
});